import { useState, useEffect } from 'react';
import ApiClient from '../../API/api';
import { useComercialContext } from '../../comercial/ComercialContext';

export const useHasCombinable = () => {
    const [hasCombinable, setHasCombinable] = useState(false);
    const { actingAsCliente } = useComercialContext();

    useEffect(() => {
        const fetch = async () => {
            try {
                const headers = actingAsCliente?.numCliente
                    ? { 'X-Acting-As-Client': actingAsCliente.numCliente }
                    : {};
                const result = await ApiClient.performRequest('cart-promotions/has-combinable', { headers });
                setHasCombinable(result === true);
            } catch {
                setHasCombinable(false);
            }
        };

        fetch();
    }, [actingAsCliente]);

    return hasCombinable;
};
